var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCollapseIcon = function SvgCollapseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "rotate(90 15 15)",
    fill: "#5C7AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.806 17.444 4.556-4.556a.764.764 0 1 1 1.08 1.081l-5.096 5.096a.762.762 0 0 1-1.08 0L9.168 13.97a.764.764 0 1 1 1.081-1.081l4.556 4.556Z",
    fill: "#fff"
  })));
};

export default SvgCollapseIcon;